import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FlexCenter,
  FlexColumnCenter,
  FlexLeftCenter,
} from "../../constant/CustomeStyle";

const productMenus = [
  { title: "Products List", to: "/product-list" },
  { title: "Menu List", to: "/menu-list" },
  { title: "Price List Editor", to: "/product-list" },
];

const inventoryMenus = [
  { title: "Warehouse Type", to: "/warehouse-type" },
  { title: "Warehouse", to: "/warehouse-list" },
  { title: "Transaction Type", to: "/transaction-type" },
  { title: "Document Type", to: "/document-type" },
  { title: "Transaction", to: "/transaction" },
  { title: "Productions", to: "/productions" },
  { title: "Inventory Items", to: "/inventory-items" },
  { title: "Recipes", to: "/recipes" },
  { title: "End of Day Records", to: "/end-of-day-records" },
  { title: "Wastage Declaration", to: "/wastage-declaration" },
];

const sittengsMenus = [
  { title: "Products", to: "/product-list" },
  { title: "Inventory", to: "/product-list" },
  { title: "Accounst", to: "/product-list" },
  { title: "Entites", to: "/product-list" },
  { title: "Tickets", to: "/product-list" },
  { title: "Automation", to: "/product-list" },
  { title: "Users", to: "/product-list" },
  { title: "3s Market", to: "/product-list" },
];

const LeftMenu = ({ productOption, settingOption }) => {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("pathname: " + location.pathname);
  let selectedMenu;

  const [topMenus, setTopMenus] = useState([]);

  if (location.pathname === "/product-list") {
    selectedMenu = "Products List";
  }
  if (location.pathname === "/menu-list") {
    selectedMenu = "Menu List";
  }

  const handlePMenu = (text, to) => {
    setPMenu(text);
    productOption(text);
    navigate(to);
  };

  const handleSMenu = (text, to) => {
    setSMenu(text);
    settingOption(text);
    navigate(to);

    text === "Products"
      ? setTopMenus(productMenus)
      : text === "Inventory"
      ? setTopMenus(inventoryMenus)
      : setTopMenus(productMenus);
  };

  const [pMenu, setPMenu] = useState(selectedMenu);
  const [sMenu, setSMenu] = useState("Products");

  return (
    <div
      style={{
        width: 206,
        height: 762,
        background: "#333C4B",
      }}
    >
      <TitleBar text={"Products"} />

      <div style={{ minHeight: 250, marginTop: 10 }}>
        <FlexColumnCenter>
          {topMenus.map((item, index) => (
            <MenuBox
              item={item}
              key={index}
              marginV={10}
              handleMenu={handlePMenu}
              menuText={pMenu}
            />
          ))}
        </FlexColumnCenter>
      </div>

      <TitleBar text={"Settings"} />

      <div style={{ minHeight: 250, marginTop: 5 }}>
        <FlexColumnCenter>
          {sittengsMenus.map((item, index) => (
            <MenuBox
              item={item}
              key={index}
              marginV={5}
              handleMenu={handleSMenu}
              menuText={sMenu}
            />
          ))}
        </FlexColumnCenter>
      </div>
    </div>
  );
};

const MenuBox = ({ item, marginV, handleMenu, menuText }) => (
  <FlexLeftCenter
    style={{
      width: 178,
      height: 36,
      border: "1px solid #C4C4C4",
      marginBottom: marginV,
      background: `${
        menuText === item.title
          ? "#CA2129"
          : "linear-gradient(180deg, rgba(75, 83, 98, 0) 0%, #4B5362 100%)"
      }`,
      cursor: "pointer",
    }}
    onClick={() => handleMenu(item.title, item.to)}
  >
    <div
      style={{
        marginLeft: 10,
        color: "#FFF",
        fontSize: 14,
        fontWeight: "600",
        fontFamily: `Poppins, sans-serif`,
      }}
    >
      {item.title}
    </div>
  </FlexLeftCenter>
);

const TitleBar = ({ text }) => (
  <FlexLeftCenter
    style={{
      background: "#CA2129",
      width: 206,
      height: 46,
    }}
  >
    <div
      style={{
        color: "#FFF",
        fontSize: 18,
        fontWeight: "600",
        fontFamily: `Poppins, sans-serif`,
        marginLeft: 20,
      }}
    >
      {text}
    </div>
  </FlexLeftCenter>
);

export default LeftMenu;
